/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Images from '../assets/images';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { CaretDownOutlined, CaretLeftOutlined, LogoutOutlined, UserOutlined, } from '@ant-design/icons'
import { Avatar, Dropdown, Menu, Space } from 'antd';
import { useAuth0 } from '@auth0/auth0-react';
import { getAuth0ProfileImageUrl, isNotNullUndefined, isNotNullUndefinedBlank, isValidEmail, toTitleCase } from '../helpers/common';
import { storage } from "../utils/storage";
import { isMobile } from 'react-device-detect';
import { guestUserName } from '../helpers/config';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedMenu, setSelectedMenu] = useState<string>("mit");
    // const { user, logout, isAuthenticated } = useAuth0();
    const [isOptionsSubMenuOpen, setIsOptionsSubMenuOpen] = React.useState(false);
    const [isAIEventsSubMenuOpen, setIsAIEventsSubMenuOpen] = React.useState(false);
    const [userName, setUserName] = useState<string>("");
    const profileImageUrl = useRef<string>("");
    const navigate = useNavigate();
    const isAuthenticatedUser = useRef(false);
    const isGuestUser = useRef(false);
    const [, setRefresh] = useState<boolean>(false);

    const syncUserData = () => {
        isAuthenticatedUser.current = JSON.parse(storage.getLocalProperty("isAuthenticated") ?? "false");
        isGuestUser.current = JSON.parse(storage.getLocalProperty("isGuestUser") ?? "false");

        if (isAuthenticatedUser.current || isGuestUser.current) {
            const defaultUserName = storage.getLocalProperty("userName") ?? "";
            let userName = defaultUserName;
            if (isAuthenticatedUser.current) {
                userName = (storage.getLocalProperty("userName") !== guestUserName) ? storage.getLocalProperty("userName") : "";
            }
            setUserName(userName);
            const defaultProfilePicture = storage.getLocalProperty("userPicture") ?? "";
            profileImageUrl.current = isNotNullUndefinedBlank(defaultProfilePicture) ? defaultProfilePicture : "";
            setRefresh(true);
        }
    };

    useEffect(() => {
        syncUserData();
        window.addEventListener("authStateChanged", syncUserData);
        return () => {
            window.removeEventListener("authStateChanged", syncUserData);
        };
    }, []);

    useEffect(() => {
        localStorage.removeItem("selectedMenu");
        const selectedMenuName = localStorage.getItem("selectedMenu");
        if (selectedMenuName) {
            setSelectedMenu(selectedMenuName);

            if (selectedMenuName === "mit" || selectedMenuName === "paradigm") {
                setIsAIEventsSubMenuOpen(true);
            } else if (selectedMenuName === "openpositions" || selectedMenuName === "closedpositions") {
                setIsOptionsSubMenuOpen(true);
            }
        }
        else {
            setIsAIEventsSubMenuOpen(true);
        }
    }, []);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const onClickNavMenu = (menuName: string) => {
        setSelectedMenu(menuName);
        localStorage.setItem("selectedMenu", menuName);

        if (menuName === "dashboard") {
            setIsOpen(!isOpen);
            navigate("/dashboard");
        }
        else if (menuName === "ai_events") {
            setIsAIEventsSubMenuOpen(!isAIEventsSubMenuOpen); //Toggle AI Recommendation
            // setIsOptionsSubMenuOpen(false);
        } else if (menuName === "mit") {
            setIsOpen(!isOpen);
            // navigate("/events/mit");
            // navigate(isMobile ? "/events/mitmobile" : "/events/mit");
            navigate(isMobile ? "/events/mitmobile" : "/");
        } else if (menuName === "paradigm") {
            navigate("/events/paradigm");
        }
        else if (menuName === "optiongraph") {
            navigate("/options/graph");
        }
        else if (menuName === "options") {
            setIsOptionsSubMenuOpen(!isOptionsSubMenuOpen); //Toggle Options
            // setIsAIEventsSubMenuOpen(false);
        } else if (menuName === "openpositions") {
            setIsOpen(!isOpen);
            navigate("/positions/open");
        } else if (menuName === "closedpositions") {
            setIsOpen(!isOpen);
            navigate("/positions/closed");
        } else {
            setIsAIEventsSubMenuOpen(false);
            // setIsOptionsSubMenuOpen(false);
        }
    };

    const profileMenu = (
        (isAuthenticatedUser.current) ?
            <Menu
                items={[
                    {
                        key: '1',
                        label: 'Logout',
                        icon: <LogoutOutlined />
                    },
                ]}
                onClick={({ key }) => {
                    if (key === '1') {
                        window.localStorage.clear();
                        storage.setLocalProperty("isGuestUser", false);
                        storage.setLocalProperty("isAuthenticated", false);
                        window.dispatchEvent(new Event("authStateChanged"));
                        navigate("/");
                    }
                }}
            /> : <></>
    );

    return (
        <div className="relative min-h-screen md:flex">
            <button
                className="block lg:hidden fixed z-50 top-[17px] left-2 items-center justify-center"
                onClick={toggleSidebar}>
                <div>
                    {/* Icon for Toggle Button */}
                    {isOpen ? (
                        // Icon for close state
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-black"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            {/* <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /> */}
                        </svg>
                    ) : (
                        // Icon for open state
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-black"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    )}
                </div>
            </button>
            <div className='fixed z-50'>
                <div className={`w-[240px] lg:w-[0px] md:py-0 md:px-0 fixed inset-y-0 left-0 transform md:relative transition-transform duration-300 ease-in-out z-50 ${isOpen ? 'translate-x-0 shadow-box' : '-translate-x-full shadow-box'}`}>
                    <div className="sidebar transition delay-700 duration-300 ease-in-out md:delay-700 md:duration-300 md:ease-in-out w-[240px] lg:w-[265px] fixed min-h-screen bg-white">
                        <div className="sidebar-header flex items-center justify-center">
                            <div className="inline-flex">
                                <img
                                    src={Images.trade}
                                    className="w-40 mt-8 hidden lg:inline-block"
                                    alt="Tradelogo"
                                />
                                <img
                                    src={Images.tradeicon}
                                    className="w-12 mt-8 hidden lg:hidden"
                                    alt="Tradelogo"
                                />
                            </div>
                        </div>
                        <button
                            className="block lg:hidden fixed z-50 top-5 right-4"
                            onClick={toggleSidebar}>
                            {/* Icon for Toggle Button */}
                            {isOpen ? (
                                // Icon for close state
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6 text-black"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                // Icon for open state
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6 text-black"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor">
                                </svg>
                            )}
                        </button>
                        <div className='block lg:hidden px-6 mt-4'>
                            <div className='flex justify-between items-center'>
                                <div>
                                    <img
                                        src={Images.trade}
                                        className=" inline-block w-32 lg:hidden"
                                        alt="Tradelogo"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="sidebar-content px-4 py-4 pt-4 lg:px-8 lg:py-6 lg:pt-8">
                            <ul className="flex flex-col w-full">
                                {/* <li className="my-px cursor-pointer" key={"dashboard"} onClick={() => onClickNavMenu("dashboard")}>
                                    <button
                                        type='button'
                                        className={`flex w-full flex-row items-center h-10 md:h-12 px-3 rounded-lg ${selectedMenu === "dashboard" ? 'bg-white shadow-[rgba(99,_99,_99,_0.2)_0px_2px_8px_0px] text-blue-midnight' : 'text-black'}`}
                                    >
                                        <span className="flex items-center justify-center text-lg">
                                            <img
                                                src={selectedMenu === "dashboard" ? Images.dashboard : Images.dashboardblue}
                                                className={`w-[34px] h-[34px] rounded-md p-1.5 shadow-[rgba(99,_99,_99,_0.2)_0px_2px_8px_0px] ${selectedMenu === "dashboard" ? 'bg-blue-midnight' : ''}`}
                                                alt="Dashboard"
                                            />
                                        </span>
                                        <span className="ml-3 text-xs md:text-sm font-semibold block lg:block">
                                            Dashboard
                                        </span>
                                    </button>
                                </li> */}

                                {/* //#region AI Recommendation */}
                                <span>
                                    <li
                                        className="my-px mt-2 cursor-pointer"
                                        key={"ai_events"}
                                        onClick={() => {
                                            onClickNavMenu("ai_events");
                                            setIsAIEventsSubMenuOpen(!isAIEventsSubMenuOpen);
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className={`flex w-full flex-row items-center h-10 md:h-12 px-3 rounded-lg ${selectedMenu === "ai_events"
                                                ? "bg-blue-midnight text-white"
                                                : "text-black"
                                                }`}
                                        >
                                            <span className="flex items-center justify-center text-lg">
                                                <img
                                                    src={selectedMenu === "ai_events" ? Images.aiwhite : Images.aigrey}
                                                    className={`w-[34px] h-[34px] rounded-md p-1.5 ${selectedMenu === "ai_events" ? 'bg-blue-midnight' : ''}`}
                                                    alt="AI"
                                                />
                                            </span>
                                            <span className="ml-3 text-xs md:text-sm font-semibold block lg:block">AI Signals</span>
                                            <span className="ml-auto text-lg">
                                                {isAIEventsSubMenuOpen ? (
                                                    <span
                                                        className={`ml-auto text-lg arrow-icon ${isAIEventsSubMenuOpen ? "open" : ""}`}
                                                    >
                                                        <CaretDownOutlined />
                                                    </span>

                                                ) : (
                                                    <span
                                                        className={`ml-auto text-lg arrow-icon ${isAIEventsSubMenuOpen ? "open" : ""}`}
                                                    >
                                                        <CaretLeftOutlined />
                                                    </span>
                                                )}
                                            </span>
                                        </button>
                                    </li>
                                    <ul className={`sub-menu ${isAIEventsSubMenuOpen ? "open" : ""} ml-2 lg:ml-4 mt-1 space-y-2 p-1`}>
                                        <li
                                            className="cursor-pointer"
                                            key={"mit"}
                                            onClick={() => onClickNavMenu("mit")}
                                        >
                                            <button
                                                type="button"
                                                className={`flex w-full flex-row items-center h-10 md:h-12 px-3 rounded-lg ${selectedMenu === "mit"
                                                    ? "bg-blue-midnight text-white"
                                                    : "text-black"
                                                    }`}
                                            >
                                                <span className="flex items-center justify-center text-lg">
                                                    <img
                                                        src={selectedMenu === "mit" ? Images.mitwhite : Images.mitgrey}
                                                        className={`w-[34px] h-[34px] rounded-md p-1.5 ${selectedMenu === "mit" ? "bg-blue-midnight" : ""
                                                            }`}
                                                        alt="MitIcon"
                                                    />
                                                </span>
                                                <span className="ml-3 text-xs md:text-sm font-semibold block lg:block">
                                                    MIT
                                                </span>
                                            </button>
                                        </li>
                                        <li
                                            className="cursor-pointer"
                                            key={"paradigm"}
                                            onClick={() => onClickNavMenu("paradigm")}
                                        >
                                            <button
                                                type="button"
                                                className={`flex w-full flex-row items-center h-10 md:h-12 px-3 rounded-lg ${selectedMenu === "paradigm"
                                                    ? "bg-blue-midnight text-white"
                                                    : "text-black"
                                                    }`}
                                            >
                                                <span className="flex items-center justify-center text-lg">
                                                    <img
                                                        src={selectedMenu === "paradigm" ? Images.parawhite : Images.paragrey}
                                                        className={`w-[34px] h-[34px] rounded-md p-1.5 ${selectedMenu === "paradigm" ? "bg-blue-midnight" : ""
                                                            }`}
                                                        alt="ParadigmIcon"
                                                    />
                                                </span>
                                                <span className="ml-3 text-xs md:text-sm font-semibold block lg:block">
                                                    Paradigm
                                                </span>
                                            </button>
                                        </li>
                                        <li
                                            className="cursor-pointer"
                                            key={"optiongraph"}
                                            onClick={() => onClickNavMenu("optiongraph")}
                                        >
                                            <button
                                                type="button"
                                                className={`flex w-full flex-row items-center h-10 md:h-12 px-3 rounded-lg ${selectedMenu === "optiongraph"
                                                    ? "bg-blue-midnight text-white"
                                                    : "text-black"
                                                    }`}
                                            >
                                                <span className="flex items-center justify-center text-lg">
                                                    <img
                                                        src={selectedMenu === "optiongraph" ? Images.graphwhite : Images.graphgrey}
                                                        className={`w-[34px] h-[34px] rounded-md p-1.5 ${selectedMenu === "optiongraph" ? "bg-blue-midnight" : ""
                                                            }`}
                                                        alt="ParadigmIcon"
                                                    />
                                                </span>
                                                <span className="ml-3 text-xs md:text-sm font-semibold block lg:block">
                                                    Option Graph
                                                </span>
                                            </button>
                                        </li>
                                    </ul>
                                </span>
                                {/* //#endregion AI Recommendation */}

                                {/* //#region Options */}
                                <span>
                                    <li
                                        className="my-px mt-2 cursor-pointer"
                                        key={"options"}
                                        onClick={() => {
                                            onClickNavMenu("options");
                                            setIsOptionsSubMenuOpen(!isOptionsSubMenuOpen);
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className={`flex w-full flex-row items-center h-10 md:h-12 px-3 rounded-lg ${selectedMenu === "options"
                                                ? "bg-blue-midnight text-white"
                                                : "text-black"
                                                }`}
                                        >
                                            <span className="flex items-center justify-center text-lg">
                                                <img
                                                    src={selectedMenu === "options" ? Images.optionicon : Images.optionblue}
                                                    className={`w-[34px] h-[34px] rounded-md p-1.5 ${selectedMenu === "options" ? "bg-blue-midnight" : ""
                                                        }`}
                                                    alt="OptionIcon"
                                                />
                                            </span>
                                            <span className="ml-3 text-xs md:text-sm font-semibold block lg:block">Options</span>
                                            <span className="ml-auto text-lg">
                                                {isOptionsSubMenuOpen ? (
                                                    <span
                                                        className={`ml-auto text-lg arrow-icon ${isOptionsSubMenuOpen ? "open" : ""}`}
                                                    >
                                                        <CaretDownOutlined />
                                                    </span>

                                                ) : (
                                                    <span
                                                        className={`ml-auto text-lg arrow-icon ${isOptionsSubMenuOpen ? "open" : ""}`}
                                                    >
                                                        <CaretLeftOutlined />
                                                    </span>
                                                )}
                                            </span>
                                        </button>
                                    </li>
                                    <ul className={`sub-menu ${isOptionsSubMenuOpen ? "open" : ""} ml-2 lg:ml-4 mt-1 space-y-2 p-1`}>
                                        <li
                                            className="cursor-pointer"
                                            key={"openpositions"}
                                            onClick={() => onClickNavMenu("openpositions")}
                                        >
                                            <button
                                                type="button"
                                                className={`flex w-full flex-row items-center h-10 md:h-12 px-3 rounded-lg ${selectedMenu === "openpositions"
                                                    ? "bg-blue-midnight text-white"
                                                    : "text-black"
                                                    }`}
                                            >
                                                <span className="flex items-center justify-center text-lg">
                                                    <img
                                                        src={selectedMenu === "openpositions" ? Images.profitwhite : Images.profitgrey}
                                                        className={`w-[34px] h-[34px] rounded-md p-1.5 ${selectedMenu === "openpositions" ? "bg-blue-midnight" : ""
                                                            }`}
                                                        alt="OpenPositionsIcon"
                                                    />
                                                </span>
                                                <span className="ml-3 text-xs md:text-sm font-semibold block lg:block">
                                                    Opened
                                                </span>
                                            </button>
                                        </li>

                                        <li
                                            className="cursor-pointer"
                                            key={"closedpositions"}
                                            onClick={() => onClickNavMenu("closedpositions")}
                                        >
                                            <button
                                                type="button"
                                                className={`flex w-full flex-row items-center h-10 md:h-12 px-3 rounded-lg ${selectedMenu === "closedpositions"
                                                    ? "bg-blue-midnight text-white"
                                                    : "text-black"
                                                    }`}
                                            >
                                                <span className="flex items-center justify-center text-lg">
                                                    <img
                                                        src={selectedMenu === "closedpositions" ? Images.closewhite : Images.closegrey}
                                                        className={`w-[34px] h-[34px] rounded-md p-1.5  ${selectedMenu === "closedpositions" ? "bg-blue-midnight" : ""
                                                            }`}
                                                        alt="ClosedPositionsIcon"
                                                    />
                                                </span>
                                                <span className="ml-3 text-xs md:text-sm font-semibold block lg:block">
                                                    Closed
                                                </span>
                                            </button>
                                        </li>
                                    </ul>
                                </span>
                                {/* //#endregion Options */}
                            </ul>
                        </div>
                        <div className='absolute bottom-8 left-0 w-full px-4'>
                            <div className="flex items-center">
                                <Dropdown overlay={profileMenu} trigger={['click']}>
                                    <a onClick={(e) => e.preventDefault()} >
                                        <Space>
                                            <Avatar icon={
                                                ((profileImageUrl.current ?? "") !== "") ?
                                                    < img src={profileImageUrl.current} className='w-5' alt="ProfileImage" />
                                                    :
                                                    <UserOutlined />
                                            } />
                                        </Space>
                                    </a>
                                </Dropdown>
                                <div className="user-details">
                                    <span className='username ml-2.5 text-black text-xs lg:text-base'>{userName}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;